
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { Snapshot, deleteSnapshot, updateSnapshot, getSnapshot } from '@/core/services/snapshot-service'
import JsonEditorVue from 'json-editor-vue'
import { useRoute, useRouter } from 'vue-router'
import { isString } from 'lodash'

export default defineComponent({
  components: { JsonEditorVue },
  setup() {
    const state = reactive({
      snapshot: null as null | Snapshot
    })

    const router = useRouter()
    const route = useRoute()

    async function update(snapshot: Snapshot) {
      if(isString(snapshot.content)) {
        snapshot.content = JSON.parse(snapshot.content)
      }
      return updateSnapshot(snapshot)
    }

    async function removeSnapshot(snapshot: Snapshot) {
      await deleteSnapshot(snapshot.id)
      router.push({ name: 'SnapshotList' })
    }

    onMounted(async () => {
      state.snapshot = await getSnapshot(route.params.id as string)
    })

    return {
      ...toRefs(state),
      removeSnapshot,
      update
    }
  }
})
